import React from 'react';
import UserInfo from '../../components/UserInfo/UserInfo';

const SiteHeader = ({ isActive, setNav }) => {
  return (
    <header className="site-header" role="banner" data-thdoc="S1">
      <div className="site-header__global">
        <div className="container container--site-header__global">
          <span id="mobile-drop-down" className="site-header__mobile-icons-menu ">
            <span
              className={`nav__ico-link sh-ico-menu menu-link ${isActive}`}
              onClick={() => (isActive === 'active' ? setNav('') : setNav('active'))}
              onKeyPress={() => {}}
              role="link"
            >
              <img src="https://cdn40.thomasnet.com/img40/ico-nav.svg" alt="" />
            </span>
          </span>
          <a href="/" className="site-header__logo wt-logo">
            <img src="https://cdn40.thomasnet.com/img40/thomas-logo-blue.svg" alt="Thomas Logo" />
          </a>
          <div className={`site-nav-container ${isActive}`}>
            <div className="snc-header">
              <span
                className={`close-menu menu-link ${isActive}`}
                onClick={() => setNav('')}
                onKeyPress={() => {}}
                role="link"
              >
                +
              </span>
            </div>
            <span
              onClick={() => setNav('')}
              className={`site-nav-container-screen menu-link ${isActive}`}
            >
              &nbsp;
            </span>
            <UserInfo />
          </div>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
